"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("@osmosys/utils");
const react_1 = tslib_1.__importDefault(require("react"));
const react_moment_1 = tslib_1.__importDefault(require("react-moment"));
const reactstrap_1 = require("reactstrap");
const Input_1 = tslib_1.__importDefault(require("reactstrap/lib/Input"));
const react_2 = require("@osmosys/react");
const EspAdapterRequest_1 = require("./EspAdapterRequest");
class Assets extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            filter: '',
            page: 0,
        };
    }
    render() {
        const { page, filter } = this.state;
        const params = {
            $page: page + 1,
            $pagesize: 10,
        };
        if (filter) {
            params.$filter = filter;
        }
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(EspAdapterRequest_1.EspAdapterRequest, { integration: this.props.integration, fn: "listAssets", variables: {
                    data: JSON.stringify(params),
                } }, data => {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(reactstrap_1.Row, null,
                        react_1.default.createElement(reactstrap_1.Col, null,
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("strong", null, "Total count"),
                                " ",
                                data.count),
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("strong", null, "Page size"),
                                " ",
                                data.pageSize),
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("a", { href: "https://developer.salesforce.com/docs/atlas.en-us.noversion.mc-apis.meta/mc-apis/base-asset-types.htm" }, "Asset types")),
                            react_1.default.createElement(Input_1.default, { type: "select", name: "filter", value: filter, onChange: e => {
                                    this.setState({
                                        filter: e.target.value,
                                    });
                                } },
                                react_1.default.createElement("option", { value: "" }, "No filters"),
                                react_1.default.createElement("option", { value: "assetType.name eq template" }, "asset -> template"),
                                react_1.default.createElement("option", { value: "assetType.name eq defaulttemplate" }, "asset -> template -> defaulttemplate"),
                                react_1.default.createElement("option", { value: "assetType.name eq message" }, "asset -> message"),
                                react_1.default.createElement("option", { value: "assetType.name eq templatebasedemail" }, "asset -> message -> templatebasedemail"),
                                react_1.default.createElement("option", { value: "assetType.name eq textonlyemail" }, "asset -> message -> textonlyemail"),
                                react_1.default.createElement("option", { value: "assetType.name eq htmlemail" }, "asset -> message -> htmlemail"),
                                react_1.default.createElement("option", { value: "assetType.name like block" }, "asset -> block")),
                            react_1.default.createElement("br", null),
                            react_1.default.createElement(react_2.OsmosysPagination, { pageCount: Math.ceil(data.count / data.pageSize), forcePage: data.page - 1, onPageChange: newPage => this.setState({
                                    page: newPage,
                                }) }),
                            react_1.default.createElement("hr", null),
                            data.items &&
                                data.items.map(item => {
                                    return (react_1.default.createElement(reactstrap_1.Card, { key: item.id, className: "mb-3", onClick: () => {
                                            utils_1.logger.info(item);
                                        } },
                                        item.name && (react_1.default.createElement(reactstrap_1.CardHeader, { tag: "h3" }, item.name)),
                                        react_1.default.createElement(reactstrap_1.CardBody, null,
                                            item.assetType && (react_1.default.createElement(reactstrap_1.CardText, { tag: "p", className: "lead" }, item.assetType && (react_1.default.createElement("span", null,
                                                item.assetType.displayName,
                                                ' ',
                                                react_1.default.createElement("small", { className: "d-inline ml-2 text-muted" },
                                                    item.assetType.name,
                                                    "-",
                                                    item.assetType.id))))),
                                            item.createdDate && (react_1.default.createElement(reactstrap_1.CardText, { tag: "p" },
                                                react_1.default.createElement("strong", null, "Created"),
                                                ' ',
                                                react_1.default.createElement(react_moment_1.default, { format: "llll" }, item.createdDate))),
                                            item.modifiedDate && (react_1.default.createElement(reactstrap_1.CardText, { tag: "p" },
                                                react_1.default.createElement("strong", null, "Edited"),
                                                ' ',
                                                react_1.default.createElement(react_moment_1.default, { format: "llll" }, item.modifiedDate))),
                                            item.content && (react_1.default.createElement("div", null,
                                                react_1.default.createElement(reactstrap_1.Label, null, "Content"),
                                                react_1.default.createElement(Input_1.default, { type: "textarea", value: item.content, disabled: true, readOnly: true, rows: 6, className: "w-100 border-1 p-2" }))),
                                            item.availableViews &&
                                                item.availableViews.length > 0 && (react_1.default.createElement(reactstrap_1.CardText, { tag: "div", className: "mt-3" },
                                                react_1.default.createElement("div", null,
                                                    react_1.default.createElement("h5", null, "Available views")),
                                                item.availableViews.map((view, i) => {
                                                    return react_1.default.createElement("li", { key: i }, view);
                                                })))),
                                        react_1.default.createElement(reactstrap_1.CardFooter, { className: "text-muted" },
                                            item.owner ? (react_1.default.createElement(react_1.default.Fragment, null,
                                                "Owned by ",
                                                item.owner.name,
                                                " <",
                                                item.owner.email,
                                                ">")) : ('No owner'),
                                            "|",
                                            item.createdBy ? (react_1.default.createElement(react_1.default.Fragment, null,
                                                "Owned by ",
                                                item.createdBy.name,
                                                " <",
                                                item.createdBy.email,
                                                ">")) : ('No creator'),
                                            "|",
                                            item.modifiedBy ? (react_1.default.createElement(react_1.default.Fragment, null,
                                                "Modified by ",
                                                item.modifiedBy.name,
                                                " <",
                                                item.modifiedBy.email,
                                                ">")) : ('No modifier'))));
                                })))));
            })));
    }
}
exports.Assets = Assets;
//# sourceMappingURL=Assets.js.map